export default "__VITE_ASSET__G75hW83Q__"